var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingOverlay',{staticClass:"loading-overlay",attrs:{"active":_vm.showLoadingOverlay},on:{"update:active":function($event){_vm.showLoadingOverlay=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }